import { Fragment } from 'react'

import { ColumbiaUniversity } from 'component/Icons/ColumbiaUniversity'

import abigail from 'assets/img/research/professors/abigail-greenleaf.jpeg'
import susan from 'assets/img/research/professors/susan-mcgregor.jpg'
import alexander from 'assets/img/research/professors/alexander-urban.jpg'
import aliHirsa from 'assets/img/research/professors/ali-hirsa.png'
import xuan from 'assets/img/research/professors/xuan-di.jpg'
import hongseok from 'assets/img/research/professors/hongseok-namkoong.jpg'
import dimitri from 'assets/img/research/professors/dimitri-livitz.jpg'
import cherylLiu from 'assets/img/research/professors/cheryl-liu.jpg'
import brianMcDermott from 'assets/img/research/professors/brian-mcdermott.jpg'
import kylaGabriel from 'assets/img/research/professors/kyla-gabriel.png'
import jamesWhitfield from 'assets/img/research/professors/james-whitfield.jpg'
import keithEllis from 'assets/img/research/professors/keith-ellis.jpg'
import derekSollberger from 'assets/img/research/professors/derek-sollberger.jpg'
import tracyNguyen from 'assets/img/research/professors/tracy-nguyen.png'
import nitinMagima from 'assets/img/research/professors/nitin-magima.jpg'
import navyaAnnapareddy from 'assets/img/research/professors/navya-annapareddy.png'
import dhruvSrivasan from 'assets/img/research/professors/dhruv-srivasan.png'
import tariniHardikar from 'assets/img/research/professors/tarini-hardikar.jpeg'
import joshuaLeiter from 'assets/img/research/professors/joshua-leiter.jpg'
import joseBento from 'assets/img/research/professors/jose-bento.jpg'
import meryemBenelajla from 'assets/img/research/professors/meryem-benelajla.png'
import jasonSaroni from 'assets/img/research/professors/jason-saroni.jpg'
import chloeMarzano from 'assets/img/research/professors/chloe-marzano.jpg'
import alexKhan from 'assets/img/research/professors/alex-khan.jpg'
import sujayShetty from 'assets/img/research/professors/sujay-shetty.jpg'

import columbiaUniversity from 'assets/img/common/columbia-university-dark.svg'
import rpi from 'assets/img/research/professors/rensselaer-polytechnic-institute.png'
import harvardMedical from 'assets/img/research/professors/harvard-medical-school.png'
import dartmouthCollege from 'assets/img/research/professors/dartmouth-college.png'
import purdueUniversity from 'assets/img/research/professors/purdue-university.png'
import princetonUniversity from 'assets/img/research/professors/princeton-university.png'
import nswcpd from 'assets/img/research/professors/nswcpd.png'
import columbiaClimateSchool from 'assets/img/research/professors/columbia-climate-school.png'
import uvaDataScience from 'assets/img/research/professors/uva-data-science.png'
import mit from 'assets/img/common/mit.png'
import rakia from 'assets/img/research/professors/rakia-logo.png'
import albertEinsteinHospital from 'assets/img/research/professors/albert-einstein-hospital-logo.svg'
import virginiaTech from 'assets/img/research/professors/virginia-tech.png'
import universityOfArizona from 'assets/img/research/professors/university-of-arizona.png'
import universityOfMaryland from 'assets/img/common/univerty-of-maryland-primary.webp'
import doQuantum from 'assets/img/research/professors/do-quantum.png'
import eyeo from 'assets/img/research/professors/eyeo-logo.svg'

export const professors = {
  title: 'Mentors',
  professors: [
    {
      id: 'columbia-university',
      name: 'Columbia University Data Science Research Institute',
      desc: (
        <Fragment>
          <p>
            The Coding School prides itself with offering students a rare opportunity to be personally mentored by leading researchers, scientists, government officials, and industry experts from some of the world’s most prestigious companies, institutions and agencies.
          </p>
          <p>
            We are honored to collaborate with Columbia University Data Science Institute and Columbia School of Engineering as our lead partners of the National High School Research Program in order to provide the highest quality research experience available to high school students.
          </p>
          <p>
            Our students recognize this privilege and rated their mentors as one of the most meaningful components of their research experience in 2025. Columbia professors and faculty, some our mentors include:
          </p>
        </Fragment>
      ),
      orgLogo: '',
      svg: <ColumbiaUniversity height={100} color="#fff" />,
    },
    {
      id: 'abigail-greenleaf',
      name: 'Abigail Greenleaf',
      desc: (
        <Fragment>
          <p>
            Dr. Abigail (Abba) Greenleaf, Assistant Professor at Columbia
            University, is a public health demographer whose research focuses on
            collecting data in low- and middle-income countries where using cell
            phones to survey populations is an increasingly viable methodology.
            In the United States, phone-based surveys have been common since the
            1980s. In areas such as Africa, until recently there was not
            sufficient cell phone ownership to create valid phone-based health
            estimates, and researchers like Dr. Greenleaf have been assessing
            the reliability of this increasingly popular approach to data
            collection.
          </p>
          <p>
            Dr. Greenleaf currently works with ICAP’s Population-Based HIV
            Impact Assessment (PHIA) project. Carried out under the leadership
            of national ministries of health, PHIA data benchmark a country’s
            progress towards controlling the HIV epidemic. Dr. Greenleaf enjoys
            this rigorous research because it is efficient, cost-effective and
            produces high-quality data that can inform targeted policies and
            programs. As COVID-19 epidemic restraints slowed progress with the
            PHIA project in several countries, Dr. Greenleaf became part of a
            team that quickly catalyzed PHIA data and participants in Lesotho to
            begin a phone-based surveillance system for coronavirus-like
            symptoms. This real-time data creates weekly estimated infection
            levels for the national ministry of health.
          </p>
        </Fragment>
      ),
      img: {
        src: abigail,
        alt: 'Abigail Greenleaf',
      },
      orgLogo: columbiaUniversity,
    },
    {
      id: 'alexander-urban',
      name: 'Alexander Urban',
      desc: (
        <Fragment>
          <p>
            Alex Urban is an Assistant Professor of Chemical Engineering and a
            core faculty-member of the Columbia Electrochemical Energy Center
            (CEEC) and the Columbia Center for Computational Electrochemistry
            (CCCE).
          </p>

          <p>
            His research interests are in understanding and discovering
            materials and processes for clean-energy applications using
            atomic-scale modeling and data science. Prior to joining the
            Department of Chemical Engineering at Columbia University in 2019,
            Alex was an independent University Fellow in the School of Chemistry
            at the University of St Andrews (UK). Alex obtained his PhD in 2012
            from FAU Erlangen-Nuremberg in Germany and conducted postdoctoral
            research at MIT and UC Berkeley. In 2019, Alex was named a Scialog
            Fellow for Advanced Energy Storage by the Research Corporation for
            Science Advancement.
          </p>
        </Fragment>
      ),
      img: {
        src: alexander,
        alt: 'Alexander Urban',
      },
      orgLogo: columbiaUniversity,
    },
    {
      id: 'ali-hirsa',
      name: 'Ali Hirsa',
      desc: (
        <Fragment>
          <p>
            Dr. Ali Hirsa is a professor at Columbia University. His research
            interests are algorithmic trading, machine learning, data mining,
            computational/quantitative finance and optimization. His focus has
            been on developing learning algorithms on signal extraction from
            data.
          </p>
          <p>
            Ali is author of “Computational Methods in Finance”, Chapman &
            Hall/CRC 2012 and co-author of “An Introduction to Mathematics of
            Financial Derivatives”, third edition, Academic Press and is the
            editor of Journal of Investment Strategies. He has several
            publications and is a frequent speaker at academic and practitioner
            conferences.
          </p>
          <p>
            Ali is co-inventor of “Methods for Post Trade Allocation” (US Patent
            8,799,146). The method focuses on allocation of filled orders
            (post-trade) on any security to multiple managed accounts which has
            to be fair and unbiased. Current existing methods lead to biases and
            the invention provides a solution to this problem.
          </p>
        </Fragment>
      ),
      img: {
        src: aliHirsa,
        alt: 'Ali Hirsa',
      },
      orgLogo: columbiaUniversity,
    },
    {
      id: 'susan-mcgregor',
      name: 'Susan E. McGregor',
      desc: (
        <Fragment>
          <p>
            Susan E. McGregor is an associate research scholar at Columbia
            University's Data Science Institute, where she co-chairs the Center
            for Data, Media & Society.
          </p>
          <p>
            McGregor's research primarily centers on security and privacy issues
            affecting journalists and media organizations. Her current work
            includes an NSF-funded project to provide readers with stronger
            guarantees about digital media by incorporating cryptographic
            signatures into digital publishing workflows. She works with natural
            language processing experts to develop novel classifiers for
            detecting abusive speech on Twitter, and is researching effective
            models for peer support with a focus on the media space. Her work in
            these and related areas has received support from the NSF, the
            Knight Foundation, Google, Columbia University, among others.
          </p>
          <p>
            As an educator, McGregor is committed to increasing the reach of
            data science education to help ensure that essential literacies
            about data-driven systems are accessible to learners of every age
            and background. Prior to her work at Columbia University, McGregor
            was the senior programmer for the News Graphics team at the Wall
            Street Journal (WSJ), a front-end programmer at the photo wire
            service MediaVast (acquired by Getty Images), and a reporter for The
            New York Amsterdam News.
          </p>
        </Fragment>
      ),
      img: {
        src: susan,
        alt: 'Susan E. McGregor',
      },
      orgLogo: columbiaUniversity,
    },
    {
      id: 'xuan-di',
      name: 'Xuan (Sharon) Di',
      desc: (
        <Fragment>
          <p>
            Dr. Xuan (Sharon) Di is an Associate Professor in the Department of
            Civil Engineering and Engineering Mechanics at Columbia University
            and serves on a committee for the Smart Cities Center in the Data
            Science Institute.
          </p>
          <p>
            Prior to joining Columbia, she was a Postdoctoral Research Fellow at
            the University of Michigan Transportation Research Institute. She
            received her Ph.D. degree from the Department of Civil,
            Environmental, and Geo-Engineering at the University of Minnesota,
            Twin Cities in 2014. Dr. Di directs the DitecT (Data and innovative
            technology-driven Transportation) Lab @ Columbia University. Her
            research lies at the intersection of game theory, dynamic control,
            and machine learning. She is specialized in emerging transportation
            systems optimization and control, shared mobility modeling, and
            data-driven urban mobility analysis. Details about DitecT Lab and
            Prof. Sharon Di's research can be found in the following link:{' '}
            <a
              href="http://sharondi-columbia.wixsite.com/ditectlab"
              rel="noreferrer"
            >
              http://sharondi-columbia.wixsite.com/ditectlab
            </a>
            .
          </p>
        </Fragment>
      ),
      img: {
        src: xuan,
        alt: 'Xuan (Sharon) Di',
      },
      orgLogo: columbiaUniversity,
    },
    {
      id: 'hongseok-namkoong',
      name: 'Hongseok Namkoong',
      desc: (
        <Fragment>
          <p>
            Hongseok Namkoong is an Assistant Professor in the Decision, Risk,
            and Operations division at Columbia Business School and a member of
            the Columbia Data Science Institute.
          </p>
          <p>
            His research interests lie at the interface of machine learning,
            operations research, and causal inference, with a particular
            emphasis on developing reliable learning methods for decision-making
            problems. He received his Ph.D. from Stanford University and worked
            as a research scientist at Facebook Core Data Science before joining
            Columbia. Hong is a recipient of several awards and fellowships,
            including best paper awards at the Neural Information Processing
            Systems conference and the International Conference on Machine
            Learning, and the INFORMS Applied Probability Society.
          </p>
        </Fragment>
      ),
      img: {
        src: hongseok,
        alt: 'Hongseok Namkoong',
      },
      orgLogo: columbiaUniversity,
    },
    {
      id: 'dimitri-livitz',
      name: 'Dimitri Livitz',
      desc: (
        <Fragment>
          <p>
            Dimitri is a chemical engineer, who approaches research
            computationally. He has worked in bioinformatics, studying the
            dynamics of cancer growth and now studies soft matter, focusing on
            microrobots.
          </p>
          <p>
            He is interested in exploring the intersection of data science and
            physical systems, and uses python and julia for his research. He is
            also excited about data visualization, and trying to present
            findings in interesting ways.
          </p>
        </Fragment>
      ),
      img: {
        src: dimitri,
        alt: 'Dimitri Livitz',
      },
      // orgLogo: '',
    },
    {
      id: 'cheryl-liu',
      name: 'Cheryl Liu',
      desc: (
        <Fragment>
          <p>
            Cheryl Liu is an Associate Professor at Columbia University. She has
            multiple years of career experience with creating machine learning,
            data mining, data visualization, and statistical models for Big Data
            problems. Her previous role was an Investment Banking Analyst, where
            she focused on raising capital for US & Canada public companies in
            energy and media industries, and had participated in a $5 billion
            merger. Before that, Liu worked with Dr. Alpert at NIST, responsible
            for solving data-driven research problems in spectroscopy with
            statistical and machine learning algorithms. Liu served as an
            organizer and reviewer for the Special Session on Metric and
            Topological Oriented Fixed Point Theorems at the American
            Mathematical Society sectional meeting. Since 2014, she has been
            invited to speak about Scholastic PDEs and Fixed Point Theorems in
            top-tier conferences and universities.
          </p>
        </Fragment>
      ),
      img: {
        src: cherylLiu,
        alt: 'Cheryl Liu',
      },
      orgLogo: columbiaUniversity,
    },
    {
      id: 'brian-mcdermott',
      name: 'Brian McDermott',
      desc: (
        <Fragment>
          <p>
            Brian McDermott is an Adjunct Professor in the Department of
            Mechanical, Aerospace, and Nuclear Engineering at Rensselaer
            Polytechnic Institute and a Principal R&D Engineer at the Naval
            Nuclear Laboratory. He manages a research portfolio spanning the
            full quantum computing stack, ranging from materials and devices to
            software and algorithms. Additionally, Brian leads development
            efforts at the intersection of high-performance computing, novel
            hardware architectures, experimental methods, and advanced
            simulations.
          </p>
        </Fragment>
      ),
      img: {
        src: brianMcDermott,
        alt: 'Brian McDermott',
      },
      orgLogo: rpi,
    },
    {
      id: 'kyla-gabriel',
      name: 'Kyla Gabriel',
      desc: (
        <Fragment>
          <p>
            Kyla Gabriel is a medical AI engineer and researcher with a
            multidisciplinary portfolio spanning clinical machine learning,
            neuroscience, and STEM education. She has developed various tools to
            improve clinical decision support and is working on innovative
            technologies to bring AI to medicine. In addition to her research
            roles at Harvard Medical School and Vanderbilt University Medical
            Center, she has taught courses on AI for medicine—including programs
            for international students through NGEN —where she focuses on making
            cutting-edge AI concepts accessible and relevant to diverse
            learners. With two master's degrees in AI and neuroscience and
            ongoing MD and PhD degrees, she is deeply passionate about education
            and is committed to expanding AI capabilities to students and
            educators and preparing the next generation to engage meaningfully
            with emerging technologies.
          </p>
        </Fragment>
      ),
      img: {
        src: kylaGabriel,
        alt: 'Kyla Gabriel',
      },
      orgLogo: harvardMedical,
    },
    {
      id: 'james-whitfield',
      name: 'Dr James Whitfield',
      desc: (
        <Fragment>
          <p>
            Professor James Daniel Whitfield graduated from Morehouse College
            and obtained his doctorate in Chemical Physics from Harvard in 2011.
            After a postdoctoral fellowship at the Vienna Center for Quantum
            Science and Technology, he is now at Dartmouth College as an
            Associate Professor in the Department of Physics and Astronomy and
            an adjunct faculty in the Department of Chemistry. Professor
            Whitfield and his group work on novel computing approaches to
            electronic structure with an emphasis on physical simulations using
            quantum computers. He also maintains an active involvement in the
            quantum education community. He serves on the advisory board at
            IBM-HBCU Quantum Center and at Qubit By Qubit, and is currently an
            Amazon Visiting Academic.
          </p>
        </Fragment>
      ),
      img: {
        src: jamesWhitfield,
        alt: 'Dr James Whitfield',
      },
      orgLogo: dartmouthCollege,
    },
    {
      id: 'keith-ellis',
      name: 'Keith Ellis',
      desc: (
        <Fragment>
          <p>
            Keith Ellis works for Purdue University as the Assistant Director,
            Online Capstone Experience for both the MS Artificial Intelligence
            and MS Data Science programs. He applies educational learning
            engineering to develop and implement sustainable frameworks for
            positive learning experiences. He serves as an eCornell Certificate
            Facilitator in Python and Risk Analysis. He also is an adjunct
            professor in Data Analytics and helps with course design at Southern
            New Hampshire University He has a background of ten years as a data
            scientist focusing in economic analysis, predictive modeling and
            geospatial data science applications, most recently in the freight
            transportation industry.
          </p>
        </Fragment>
      ),
      img: {
        src: keithEllis,
        alt: 'Keith Ellis',
      },
      orgLogo: purdueUniversity,
    },
    {
      id: 'derek-sollberger',
      name: 'Derek Sollberger',
      desc: (
        <Fragment>
          <p>
            Derek Sollberger is a lecturer with the Center for Statistics and
            Machine Learning (CSML) at Princeton University, where he teaches
            courses in data science, machine learning, and artificial
            intelligence for a variety of students. His research is in
            educational research in order to assist professors measure and
            improve classroom environments and information retention.
            Previously, after majoring in applied mathematics, he taught at the
            University of California Merced. There, he taught courses in
            calculus, statistics, bioinformatics, and sports analytics.
          </p>
        </Fragment>
      ),
      img: {
        src: derekSollberger,
        alt: 'Derek Sollberger',
      },
      orgLogo: princetonUniversity,
    },
    {
      id: 'tracy-nguyen',
      name: 'Tracy Nguyen',
      desc: (
        <Fragment>
          <p>
            Tracy is a SEP Quality Assurance (QA) Auditor with the Naval Surface
            Warfare Center in Philadelphia (NSWCPD). In addition, she is also
            pursuing a Doctor of Philosophy (PhD) in Systems Engineering as part
            of the Naval Postgraduate School (NPS). In her 14 years of
            professional engineering career, she has served as the Lead Systems
            Engineer (LSE) and Configuration Manager (CM) for NSWCPD where she
            was in charge of the system engineering activities of the DDG 51
            Ship Control System (SCS) Program.
          </p>
        </Fragment>
      ),
      img: {
        src: tracyNguyen,
        alt: 'Tracy Nguyen',
      },
      orgLogo: nswcpd,
    },
    {
      id: 'nitin-magima',
      name: 'Nitin Magima',
      desc: (
        <Fragment>
          <p>
            Nitin is a climate risk specialist and advocate for tech
            democratization, working at the intersection of climate resilience
            and data science. At Columbia University’s Climate School, he
            collaborates with governments and leading international
            organizations, including the World Food Programme, World Bank, and
            NASA SERVIR, to co-design strategies that address climate risks and
            build long-term resilience. Nitin’s expertise includes developing
            early warning systems, climate forecasting tools, and data-driven
            dashboards that translate complex climate data into actionable
            insights. He led the data pipeline design for the Rockefeller
            Foundation-funded Climate Finance (CliF) Vulnerability Index and has
            contributed to projects with the Bezos Earth Fund, Tech:NYC, and the
            Taylor Geospatial Institute.
          </p>
        </Fragment>
      ),
      img: {
        src: nitinMagima,
        alt: 'Nitin Magima',
      },
      orgLogo: columbiaClimateSchool,
    },
    {
      id: 'navya-annapareddy',
      name: 'Navya Annapareddy',
      desc: (
        <Fragment>
          <p>
            Navya Annapareddy is a Ph.D. Candidate and Distinguished Teaching
            Fellow at the University of Virginia’s School of Data Science. She
            holds a B.S. in Systems Engineering and an M.S. in Data Science. Her
            research spans applied machine learning, statistical modeling, and
            computer vision across domains such as health, public
            infrastructure, and policy. She previously worked as a machine
            learning engineer on projects ranging from bias detection in
            algorithmic systems to infectious disease modeling. She was most
            recently named a 2025 COVES Policy Fellow by the Virginia Academy of
            Science, Engineering, and Medicine to serve under the Joint
            Commission of Technology.
          </p>
        </Fragment>
      ),
      img: {
        src: navyaAnnapareddy,
        alt: 'Navya Annapareddy',
      },
      orgLogo: uvaDataScience,
    },
    {
      id: 'dhruv-srivasan',
      name: 'Dhruv Srivasan',
      desc: (
        <Fragment>
          <p>
            Dhruv Srinivasan is a PhD candidate at MIT working on scalable
            quantum computing architectures. As a Physics and Mechanical
            Engineering undergraduate student at the University of Maryland,
            Dhruv conducted research in Professor Avik Dutt's FloQuET Group in
            digital quantum algorithms and nanophotonics. He also chaired
            outreach events as Vice President of UMD's Undergraduate Quantum
            Association. Dhruv’s publications range from digital quantum
            algorithms and simulation to nanophotonic sensing, and can be found
            in his{' '}
            <a
              href="https://scholar.google.com/citations?hl=en&user=HFJ4e1kAAAAJ"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Scholar
            </a>{' '}
            profile.
          </p>
        </Fragment>
      ),
      img: {
        src: dhruvSrivasan,
        alt: 'Dhruv Srivasan',
      },
      orgLogo: mit,
    },
    {
      id: 'tarini-hardikar',
      name: 'Tarini Hardikar',
      desc: (
        <Fragment>
          <p>
            Tarini is a quantum chemist who is passionate about developing
            scientific software to solve unique challenges and improve
            scientific understanding. She completed her Ph.D. at the University
            of California, Berkeley, developing new methodologies for excited
            state-specific quantum chemistry, with her advisor, Dr. Eric
            Neuscamman. Previously, she worked as a researcher at Dartmouth
            College, with Dr. James Whitfield, testing various fermion-to-qubit
            mappings. As an undergraduate at Colby College, she studied
            chemistry and mathematics, and developed an early interest in
            quantum computing.
          </p>
        </Fragment>
      ),
      img: {
        src: tariniHardikar,
        alt: 'Tarini Hardikar',
      },
      orgLogo: dartmouthCollege,
    },
    {
      id: 'joshua-leiter',
      name: 'Joshua Leiter',
      desc: (
        <Fragment>
          <p>
            Joshua Leiter, Ph.D. mathematical physicist and geometer turned
            entrepreneur. After years of schooling where Josh was untangling the
            curvature of spacetime, publishing on Einstein-Cartan (ECSK)
            gravity, invariants, and differential-geometric methods, he founded
            Rakia, a business to translate deep mathematics into practical
            technology. His work ranges from antenna‐field synthesis and RF
            signal detection via software defined radios, to Python-driven data
            pipelines, Maple coding for differential geometrical software, and
            finally GUI design. Josh loves building clear, modular solutions
            that help accelerate research and development, and communicate
            complex ideas with elegance. He strives for rigorous insight,
            creative problem-solving, and minds yearning to turn high-concept
            theory into real-world impact. Prior to Rakia, Joshua served as a
            Scientist at the Naval Information Warfare Center in San Diego.
          </p>
        </Fragment>
      ),
      img: {
        src: joshuaLeiter,
        alt: 'Joshua Leiter',
      },
      orgLogo: rakia,
    },
    {
      id: 'jose-bento',
      name: 'Jose Bento',
      desc: (
        <Fragment>
          <p>
            Jose Bento is a Quantum Scientist at Albert Einstein Hospital
            passionately working with applications and development of quantum
            algorithms for the benefit of health sciences. He holds a MSc in
            physics and is currently a PhD candidate in quantum mechanics. You
            can find his publications listed under "Bento Montenegro"
          </p>
        </Fragment>
      ),
      img: {
        src: joseBento,
        alt: 'Jose Bento',
      },
      orgLogo: albertEinsteinHospital,
    },
    {
      id: 'meryem-benelajla',
      name: 'Meryem Benelajla',
      desc: (
        <Fragment>
          <p>
            Meryem is the Photonics Characterization Lead at Eyeo. She turned
            her curiosity of light and tiny things into a career in quantum
            photonics and nanotech. She has been fortunate with her career to
            study and work in France, Germany, the Netherlands, Belgium, and the
            USA—chasing light beams and big ideas across the globe! Meryem holds
            a Ph.D. in physics and, currently, is also pursuing an MBA to
            combine science with business and innovation.
          </p>
        </Fragment>
      ),
      img: {
        src: meryemBenelajla,
        alt: 'Meryem Benelajla',
      },
      orgLogo: eyeo,
    },
    {
      id: 'jason-saroni',
      name: 'Jason Saroni',
      desc: (
        <Fragment>
          <p>
            Jason is a Postdoctoral Associate at Virginia Tech and part of the
            Virginia Tech Center for Quantum Information Science and
            Engineering. Jason earned his PhD in Condensed Matter Physics from
            Iowa State University where he conducted research on quantum and
            classical simulations of physics systems as a graduate member of the
            SQMS collaboration hosted by Fermilab. Jason has interned at IBM
            Research headquarters in New York and his current interest is on
            open quantum systems and quantum algorithms.
          </p>
        </Fragment>
      ),
      img: {
        src: jasonSaroni,
        alt: 'Jason Saroni',
      },
      orgLogo: virginiaTech,
    },
    {
      id: 'alex-khan',
      name: 'Alex Khan',
      desc: (
        <Fragment>
          <p>
            Alex Khan is a strategic advisor, entrepreneur, and educator in
            quantum computing and AI through his company Aligned IT, LLC. He is
            a Visiting Assistant Research Scholar at the University of Maryland
            and past Fellow at the National Quantum Lab and has also taught
            quantum computing at Harrisburg University. He is the author of the
            book "Quantum Computing Experimentation with Amazon Braket". At his
            startup ZebraKet he developed solutions for supply chain
            optimization using quantum inspired solvers and leak detection for
            the energy industry using AI/ML. He is now leading a team in the
            XPRIZE Quantum Applications competition in the epigenetic assembly
            use case.
          </p>
        </Fragment>
      ),
      img: {
        src: alexKhan,
        alt: 'Alex Khan',
      },
      orgLogo: universityOfMaryland,
    },
    {
      id: 'chloe-marzano',
      name: 'Chloe Marzano',
      desc: (
        <Fragment>
          <p>
            Chloe is a PhD candidate at the University of Arizona. Chloe’s love
            of physics started in high school when she would spend hours
            scouring through Wikipedia articles about Relativity, Quantum
            Mechanics, and Calculus. She would frequently stay late after class
            to talk with my calculus and physics teachers about questions she
            had or to show them the newest physics and/or math project she’d
            given herself to work on. Her largest self-assigned challenge was to
            prove Kepler’s 2nd Law herself without looking up a solution, which
            took 2 years and led her down endless rabbit-holes and dead-ends.
            Eventually she did prove it and learned so much about calculus and
            physics along the way, especially through her dead-ends.
          </p>
        </Fragment>
      ),
      img: {
        src: chloeMarzano,
        alt: 'Chloe Marzano',
      },
      orgLogo: universityOfArizona,
    },
    // {
    //   id: 'sujay-shetty',
    //   name: 'Sujay Shetty',
    //   desc: (
    //     <Fragment>
    //       <p>Before entering medical school, Sujay majored in computer science with honors at the University of Maryland College Park and interned in labs at UMCP, UMSOM, and Harvard Medical School. After graduation, Sujay worked for two years at the National Quantum Laboratory at Maryland, UMSOM, and the National Institutes of Health. He is also a Peer Advisor for Do Quantum, a nonprofit quantum research accelerator for UMCP students.</p>
    //     </Fragment>
    //   ),
    //   img: {
    //     src: sujayShetty,
    //     alt: 'Sujay Shetty',
    //   },
    //   orgLogo: doQuantum,
    // },
  ],
}
